import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=6fb82c95&scoped=true"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=6fb82c95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb82c95",
  null
  
)

export default component.exports